import { checkIntroMedia, stopChanged } from 'aria-viewer/tour/tourActions'
import { TourActions } from 'aria-viewer/tour'
import { getCurrentPoint } from 'aria-viewer/utils/functions'
import { updateImageCache } from 'aria-viewer/media/mediaCache'
import { MEDIA_LOADING_STATUS } from 'aria-viewer/tour/constants'
import { openLastSlideAlertModal } from 'aria-viewer/modal/modalActions'
import { type as BatchType } from 'redux-batch-middleware'
import { trigger, events } from '../../legacy'

export default ({ getState, dispatch }) => next => action => {
    const actions = action.type === BatchType ? action.payload : [action]
    const previousState = getState()

    next(action)

    let updateCache = false
    let processAction = false

    let allowUpdate = actions.forEach(action => {
        if (
            action.type === TourActions.SET_POINT ||
            action.type === TourActions.SET_STOP ||
            action.type === TourActions.GO_TO_POINT
        ) {
            processAction = true
        }

        // Allow caching only after the main media has loaded
        if (
            action.type == TourActions.MAIN_MEDIA_LOADING_STATUS &&
            action.loadingStatus == MEDIA_LOADING_STATUS.loaded
        ) {
            updateCache = true
        }
    })

    // Exit function if no updates are needed
    if (!processAction && !updateCache) return

    const state = getState()

    const previousStopIndex = previousState.getIn(['tour', 'stops', 'current'])
    const previousTour = previousState.getIn(['tour', 'tours', 'current']) || -1
    const stopsList = state.getIn(['tour', 'stops']).get('list')
    const currentStopIndex = state.getIn(['tour', 'stops', 'current'])
    const point = getCurrentPoint(state.get('tour'))

    // Update the cache for images
    if (updateCache) {
        updateImageCache(stopsList, currentStopIndex, point)(dispatch, getState)
    }

    if (processAction) {
        const currentTour = state.getIn(['tour', 'tours', 'current'])
        const hasPreviousAndCurrentStopInitialized =
            previousState.getIn(['tour', 'stops', 'current']) !== null ||
            state.getIn(['tour', 'stops', 'current']) !== null

        /*
		 * Determine if Stop Changed
		 */
        if (
            /*
				 * Case one:
				 * 	If we have a previous stop and current stop have been intialized
				 */

            hasPreviousAndCurrentStopInitialized &&
            /*
				 * Case two:
				 * 	If we have a previouse stop and our stop actually changed?
				 */
            (previousStopIndex !== currentStopIndex ||
                /* 
				 * Case three:
				 * 	If we changed tours and our tour changed?
				 *  - Since stop index may not neccessarily change between switching tours
				 */
                (previousTour && currentTour && previousTour !== currentTour))
        ) {
            // we will dispatch stop changed event on tour switch.
            const currentStop = stopsList.get(currentStopIndex)
            const previousStop = stopsList.get(previousStopIndex)

            if (!currentStop) return // only dispatch if we have a stop

            dispatch(stopChanged(previousStop, currentStop))

            trigger(events.stopChanged, { stopid: currentStop.stopid })
        }

        //last slide modal
        if (currentStopIndex === stopsList.size - 1) {
            setTimeout(() => {
                dispatch(openLastSlideAlertModal())
            }, 2000)
        }

        //Check for intro media
        let checkIntroVideo = actions.some(action => {
            return action.type === TourActions.SET_STOP || (action.type === TourActions.GO_TO_POINT && point.main)
        })

        if (checkIntroVideo) {
            dispatch(checkIntroMedia())
        }
    }
}
